module.exports = __webpack_public_path__ + "static/media/whole-article-image1.a596fb0a.jpg";